import React from "react";

const Nosotros = () => {
  return (
    <div>
      <p>Rodrigo roa Pineda</p>
      <p>Cra 8 n 26 06 Yopal</p>
      <p>3228305258</p>
      <p>www.ecoroa.org</p>
      <p>comercial@ecoroa.org</p>
    </div>
  );
};

export default Nosotros;
